<template>
  <div>
    <div v-if="loading" class="page-loading">
      <Loading />
    </div>
    <div v-else>
      <div class="em-g p-20 bg-white rad-10">
        <header>{{ $t("Package.myPackages") }}</header>
        <div class="page-content center-form">
          <NotFoundContent v-if="!sortedPackages" 
          :message="$t('Custom.notFoundResult')" />
          <table v-else class="table">
            <thead>
              <tr>
                <th>{{ $t("Package.packageTitle") }}</th>
                <th>{{ $t("Package.days") }}</th>
                <th>{{ $t("Package.startedDate") }}</th>
                <th>{{ $t("Package.endDate") }}</th>
                <th>{{ $t("Package.endedDate") }}</th>
                <th>{{ $t("Package.status") }}</th>
                <th>{{ $t("Package.price") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pkg in sortedPackages" :key="pkg.id">
                <td>{{ pkg.package.title }}</td>
                <td>{{ pkg.package.days }}</td>
                <td>{{ pkg.startedDate }}</td>
                <td>{{ pkg.endDate }}</td>
                <td>{{ pkg.endedDate }}</td>
                <td>
                  <span :class="getStatusClass(pkg.status)" class="btn-state">
                    {{ getStatusText(pkg.status) }}
                  </span>
                </td>
                <td>{{ formatCurrency(pkg.price) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import Loading from "@/components/user/layout/LoadingComponent.vue";
import NotFoundContent from '@/components/user/common/NotFoundContent.vue'; 
import { getUserPackages } from "@/api/package.api";

export default {
  name: "MyPackagesComponent",
  components: {
    Loading,
    NotFoundContent,
  },
  data() {
    return {
      loading: true, // Initialize loading state
      packages: [],
    };
  },
  async mounted() {
    this.$emit("loading", true);
    await this.fetchMyPackages();
    this.$emit("loading", false);
  },
  computed: {
    sortedPackages() {
      if (!this.packages) return null;
      return this.packages.sort((a, b) => {
        if (a.status === 1 && b.status !== 1) return -1;
        if (a.status !== 1 && b.status === 1) return 1;
        return 0;
      });
    },
  },
  methods: {
    async fetchMyPackages() {
      try {
        const response = await getUserPackages();
        if (response.data.status) {
          this.packages = response.data.data;
        } else {
          console.error("Failed to fetch user packages:", response.data.msg);
        }
      } catch (error) {
        console.error("An error occurred while fetching user packages:", error);
      } finally {
        this.loading = false;
      }
    },
    getStatusClass(status) {
      switch (status) {
        case 0:
          return "status-completed";
        case 1:
          return "status-active";
        default:
          return "";
      }
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return this.$t("Package.completed");
        case 1:
          return this.$t("Package.active");
        default:
          return this.$t("Package.unknown");
      }
    },
    formatCurrency(value) {
      return `$${value}`;
    },
  },
};
</script>

<style scoped>
.em-g {
  margin: 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px 12px;
  border: 1px solid #ddd;
}

.status-pending {
  color: #ffc107;
}

.status-active {
  background: #28a7455e;
  color: #28a745;
}

.status-completed {
  background: #17a2b86b;
  color: #17a2b8;
}
.status-cancel {
  color: #dc3545;
}
</style>
